import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from 'pdfmake/build/vfs_fonts';
import useDate from "../day";
import figureFormatter from "@/services/utils/figureFormatter";
import { loadImageAsBase64 } from "@/services/utils/global";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
  SulaimanLipi: {
    normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
};

const printMushak63 = () => {
  const { formatDate } = useDate();
  const { commaFormat } = figureFormatter();

  const exportToPdfMushak = async (companyInfo, invoice, user) => {
      const imagePath = await loadImageAsBase64('/app-assets/images/gov_seal.png');

      const doc = {
      pageSize: "A4",
      pageMargins: [30, 85, 30, 30],
      defaultStyle: {
        font: "SulaimanLipi",
        fontSize: 10
      },
      header: getHeader(imagePath),
      footer: getFooter(),
      content: getContent(companyInfo, invoice, user),
      info: {
        title: 'মূসক-৬.৩'
      },
      styles: styles
    };

    pdfMake.createPdf(doc).open();
  }

  const getContent = (companyInfo, invoice, user) => {
    return [
      {
        stack: [
          { text: 'নিবন্ধিত ব্যক্তির নাম: ' + companyInfo.name, alignment: 'left', fontSize: 10, margin: [60, 0, 0, 0] },
          { text: 'নিবন্ধিত ব্যক্তির বিআইএন: ' + (companyInfo.vat_no || ''), alignment: 'left', fontSize: 10, margin: [60, 0, 0, 0] },
          { text: 'চালানপত্র ইস্যুর ঠিকানা: ' + companyInfo.address , alignment: 'left', fontSize: 10, margin: [60, 0, 0, 0] },
        ],
        alignment: 'center',
        margin: [0, 0, 0, 10]
      },

      getHeadTable(invoice),
      {
        style: 'tableExample',
        margin: [0, 10, 0, 10],
        table: {
          headerRows: 2,
          widths: [20, '*', 30, 22, 'auto', 'auto', 25, 25, 35, 30, 'auto'],
          body: getTableBody(invoice)
        },
        layout: {
          hLineWidth: () => 0.5,
          vLineWidth: () => 0.5,
          hLineColor: () => '#000',
          vLineColor: () => '#000',
          paddingTop: () => 4,
          paddingBottom: () => 4
        }
      },
      
      {
        columns: [
          { width: '60%', text: 'প্রতিষ্ঠান কর্তৃপক্ষের অনুমোদিত ব্যক্তির নাম: ' },
          { width: '40%', text: 'পদবি: ' }
        ],
        margin: [0, 20, 0, 15]
      },
      {
        columns: [
          { width: '60%', text: 'স্বাক্ষর:' },
          { width: '40%', text: 'সীল:' }
        ],
        margin: [0, 0, 0, 20]
      }
    ];
  }

  const getTableBody = (invoice) => {
    const header = getTableHead();
    const headerNumber = getTableHeadNumber();
    const row = getTableRow(invoice)
    const total = getTableTotal(invoice)
    return [
      header,
      headerNumber,
      ...row,
      total
    ]
  }

  const getTableHeadNumber = () => {
    const nums = ['(১)', '(২)', '(৩)', '(৪)', '(৫)', '(৬)', '(৭)', '(৮)', '(৯)', '(১০)', '(১১)'];
    return nums.map(function (n) {
      return { text: n, style: 'tableHeaderNumber' };
    });
  }

  const getLineItems = (invoice) => {
    const items = [];
    if (invoice.general && Array.isArray(invoice.general)) items.push(...invoice.general);
    if (invoice.account_general && Array.isArray(invoice.account_general)) items.push(...invoice.account_general);
    return items;
  }

  const getLineDescription = (item) => {
    if (item.product && item.product.name) return item.product.name;
    if (item.description) return item.description;
    if (!item.account_head_name) return '';
    return item.account_head_name;
  }

  const getContactField = (contact, field) => {
    if (!contact) return '';
    if (!contact[field]) return '';
    return contact[field];
  }

  const getContactAddress = (contact) => {
    if (!contact) return '';
    return getProfileItemByField(contact.profile_items, 'billing_address');
  }

  const getUnitName = (product) => {
    if (!product || !product.description) return '';
    if (!product.description.unit) return '';
    if (!product.description.unit.name) return '';
    return product.description.unit.name;
  }

  const getTableRow = (invoice) => {
    const lineItems = getLineItems(invoice);
    if (!lineItems.length) return [];
    return lineItems.map((item, index) => {
      const productName = getLineDescription(item);
      const quantity = item.quantity || 0;
      const unit = getUnitName(item.product);
      let unitPrice = item.rate || 0;
      let amount = quantity*unitPrice;

      if (invoice.vat_type == 'vat_inclusive' && quantity > 0){
          unitPrice = item.rate - (item.vat_amount / quantity)
          amount = item.amount;
      }

      return [
        { text: convertToBanglaNumber(index + 1) + '।', alignment: 'center', fontSize: 8 },
        { text: productName, alignment: 'left', fontSize: 8 },
        { text: unit, alignment: 'center', fontSize: 8 },
        { text: quantity.toString(), alignment: 'right', fontSize: 8 },
        { text: unitPrice.toFixed(2), alignment: 'right', fontSize: 8 },
        { text: commaFormat(amount), alignment: 'right', fontSize: 8 },
        { text: 0, alignment: 'right', fontSize: 8 },
        { text: 0, alignment: 'right', fontSize: 8 },
        { text: item.vat, alignment: 'right', fontSize: 8 },
        { text: commaFormat(item.vat_amount), alignment: 'right', fontSize: 8 },
        { text: commaFormat(item.total_amount), alignment: 'right', fontSize: 8 }
      ];
    });
  };

  const getTableTotal = (invoice) => {
    const lineItems = getLineItems(invoice);
    if (!lineItems.length) return [];

    let totalQuantity = 0;
    let totalAmount = 0;
    let totalVatAmount = 0;
    let totalWithVat = 0;

    lineItems.forEach(item => {
      const quantity = item.quantity || 0;
      const unitPrice = item.rate || 0;
      const vatAmount = item.vat_amount || 0;
      const totalLineAmount = item.total_amount || 0;
      let amount = quantity * unitPrice;

      if (invoice.vat_type == 'vat_inclusive'){
         amount = item.amount || 0
      }

      totalQuantity += quantity;
      totalAmount += amount;
      totalVatAmount += vatAmount;
      totalWithVat += totalLineAmount;
    });

    return [
        { text: 'মোট', colSpan:3, style: 'tableHeaderSmall'}, {}, {},
        { text: totalQuantity, alignment: 'right', fontSize: 8, bold: true },
        { text: '', alignment: 'right', fontSize: 8 },
        { text: commaFormat(totalAmount), alignment: 'right', fontSize: 8, bold: true },
        { text: '0', alignment: 'right', fontSize: 8 },
        { text: '0', alignment: 'right', fontSize: 8 },
        { text: '', alignment: 'right', fontSize: 8 },
        { text: commaFormat(totalVatAmount), alignment: 'right', fontSize: 8, bold: true },
        { text: commaFormat(totalWithVat), alignment: 'right', fontSize: 8, bold: true }
    ];
  };

  const getTableHead = () => {
    return [
      { text: 'ক্রমিক', style: 'tableHeaderSmall' },
      { text: 'পণ্য/সেবার\nবিবরণ', style: 'tableHeaderSmall' },
      { text: 'সরবরাহের\nএকক', style: 'tableHeaderSmall' },
      { text: 'পরিমাণ', style: 'tableHeaderSmall' },
      { text: 'একক মূল্য\n(টাকায়)', style: 'tableHeaderSmall' },
      { text: 'মোট মূল্য\n(টাকায়)', style: 'tableHeaderSmall' },
      { text: 'সম্পূরক\nশুল্ক (%)', style: 'tableHeaderSmall' },
      { text: 'সম্পূরক\nশুল্ক (৳)', style: 'tableHeaderSmall' },
      { text: 'মূসক হার/\nসুনির্দিষ্ট কর', style: 'tableHeaderSmall' },
      { text: 'মূসক/সুনির্দিষ্ট করের\nপরিমাণ (৳)', style: 'tableHeaderSmall' },
      { text: 'শুল্ক ও করসহ\nমূল্য', style: 'tableHeaderSmall' }
    ];
  };

  const getHeader = (imagePath) => {
    return {
    margin: [60, 30, 60, 0],
    stack: [
      {
        columns: [
          {
            image: imagePath,
            width: 50,
            height: 50,
          },
          {
            width: '*',
            stack: [
              {
                text: 'গণপ্রজাতন্ত্রী বাংলাদেশ সরকার',
                style: 'headerCenter',
              },
              {
                text: 'জাতীয় রাজস্ব বোর্ড',
                style: 'headerCenter',
                margin: [0, 5, 0, 2],
              },
              {
                text: 'কর চালানপত্র',
                style: 'subHeaderCenter',
                margin: [0, 0, 0, 3],
                fontSize: 10
              },

              {
                text: '[বিধি ৪০ এর উপ-বিধি (১) এর দফা (গ) ও দফা (চ) দ্রষ্টব্য]',
                style: 'subHeaderCenter',
                margin: [0, 0, 10, 0],
                fontSize: 10
              },
            ],
          },
          {
            width: 50,
            margin: [0, 30, 0, 0],
            table: {
              widths: ['*'],
              body: [
                [
                  {
                    text: 'মূসক-৬.৩',
                    alignment: 'center'
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: () => 1,
              vLineWidth: () => 1,
              hLineColor: () => '#000',
              vLineColor: () => '#000',
            },
          },
        ],
      },
    ],
    };
  };

  const getHeadTable = (invoice) => {
    return {
      layout: 'noBorders',
      table: {
        fontSize: 13,
        widths: ['50%', '50%'],
        body: [
          [
            { text: 'ক্রেতার নাম: ' + getContactField(invoice.contact, 'name'), alignment: 'left', fontSize: 10},
            { text: 'চালানপত্র নম্বর: ' + invoice.bill_number, alignment: 'right', fontSize: 10 }
          ],
          [
            { text: 'ক্রেতার বিআইএন: ' + getContactField(invoice.contact, 'bin_no'), alignment: 'left', fontSize: 10},
            { text: 'ইস্যুর তারিখ: ' + formatDate(new Date(invoice.date)).split(' ')[0], alignment: 'right', fontSize: 10 }
          ],
          [
            {
              text: 'ক্রেতার ঠিকানা: ' + getContactAddress(invoice.contact), alignment: 'left', fontSize: 10, margin: [0, 0, 0, 3]
            },
            { text: 'ইস্যুর সময়: ' + (invoice.updated_at_time || '') , alignment: 'right', fontSize: 10 }
          ],
          [
            { text: 'সরবরাহের গন্তব্যস্থল: ' + (invoice.destination_address || '') , colSpan: 2, alignment: 'left', fontSize: 10},
            {}
          ],
          [
            { text: 'যানবাহনের প্রকৃতি ও নম্বর: ' + (invoice.transport_reference || ''), colSpan: 2, alignment: 'left', fontSize: 10},
            {}
          ]
        ]
      },
      margin: [0, 5, 0, 10]
    }
  }

  const getFooter = () => {
    return {
      margin: [60, 0, 60, 20],
      columns: [
        {
          width: '100%',
          text:
            '১. সকল প্রকার কর ব্যতীত মূল্য।\n' +
            '২. এস.আর.ও নং -১৩৫-আইন/২০২৪/২৪১-মূসক, তারিখ: ২৭ মে, ২০২৪ দ্বারা প্রণীত।',
          style: 'footerNote'
        }
      ]
    };
  }

  const convertToBanglaNumber = (number) => {
    const banglaDigits = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
    return number.toString().split('').map(d => banglaDigits[d] || d).join('');
  };

  const getProfileItemByField = (profile_items, keyValue) => {
    if (!profile_items || !Array.isArray(profile_items)) return '';
    const item = profile_items.find(item => item.field === keyValue);
    if (!item) return '';
    return item.value;
  }

  const styles = {
    headerCenter: {
      fontSize: 14,
      alignment: "center",
    },
    subHeaderCenter: {
      fontSize: 11,
      alignment: "center"
    },
    smallCenter: {
      fontSize: 9,
      alignment: "center",
    },
    tableHeader: {
      bold: true,
      decoration: "underline"
    },
    tableHeaderSmall: {
      fontSize: 8,
      alignment: "center",
      lineHeight: 1.1
    },
    tableHeaderNumber: {
      fontSize: 7,
      alignment: "center"
    },
    footerNote: {
      fontSize: 8,
    }
  };

  return {
    exportToPdfMushak
  }
}

export default printMushak63;
